import { configureStore } from '@reduxjs/toolkit'
import { cartReducer, uiSlice } from 'cart'

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    ui: uiSlice.reducer,
  },
})

// https://react-redux.js.org/tutorials/typescript-quick-start#define-root-state-and-dispatch-types
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
